import axios from 'axios';
import config from '../config';
var otherUrl = config.otherUrl
export const getWeight = data => {
  return axios({
    url: otherUrl,
    method: 'post',
    data,
    headers: config.headers
  })
};



// WEBPACK FOOTER //
// ./src/api/moudules/otherUrl.js